import React, { useContext } from "react";
import { connect } from "react-redux";
import { Table } from "../../view/Table";
import CentralCredentialsTableRow from "./CentralCredentialsTableRow";
import CentralCredentialsTableRowSkeleton from "./CentralCredentialsTableRowSkeleton";
import { debug } from "../../utils";
import { TableContext } from "../../index";


function CentralCredentialsTable({ centralCredentials }) {

    const { config } = useContext(TableContext);

    // Client-side filtering based on searchTerm from context
    const filteredResults = centralCredentials.filter((item) => {
        const term = (config.searchTerm || '').toLowerCase();
        if (!term) return true;

        const name = (item.ccname || '').toLowerCase();
        const user = (item.username || '').toLowerCase();

        return name.includes(term) || user.includes(term);
    });

    const headers = [
        { name: 'NAME' },
        { name: 'USERNAME' },
        { name: 'PASSWORD' },
    ]

    return (
        <>
            <Table headers={headers} elements={filteredResults} className="mt-4">
                {config.isLoading ? (
                    Array.from(new Array(5)).map((_, index) => (
                        <CentralCredentialsTableRowSkeleton key={index} index={index} />
                    ))
                ) : (
                    filteredResults.map((centralCredential, index) => <CentralCredentialsTableRow key={index} data={centralCredential} index={index} />)
                )}
            </Table>
            {!config.isLoading && filteredResults.length === 0 && (
                <div className="oct_empty-state-v2">
                    <div className="oct_empty-state-title">No records found</div>
                    <div>Try adjusting your search or filters to find what you're looking for.</div>
                </div>
            )}
        </>
    );
}

function mapStateToProps(state) {
    debug("AuthServerTable mapStateToProps", state);
    const authPage = state.authPage;
    return {
        centralCredentials: authPage.centralCredentials || []
    };
}

export default connect(mapStateToProps)(CentralCredentialsTable);
